import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      data-testid="table-column-dnd-icon"
      {...props}
    >
      <path d="M5.12494 9.25C5.12494 8.76675 4.73319 8.375 4.24994 8.375C3.76669 8.375 3.37494 8.76675 3.37494 9.25C3.37494 9.73325 3.76669 10.125 4.24994 10.125C4.73319 10.125 5.12494 9.73325 5.12494 9.25Z" fill="#475161" />
      <path d="M5.12494 4.75C5.12494 4.26675 4.73319 3.875 4.24994 3.875C3.76669 3.875 3.37494 4.26675 3.37494 4.75C3.37494 5.23325 3.76669 5.625 4.24994 5.625C4.73319 5.625 5.12494 5.23325 5.12494 4.75Z" fill="#475161" />
      <path d="M9.37494 9.25C9.37494 8.76675 8.98319 8.375 8.49994 8.375C8.01669 8.375 7.62494 8.76675 7.62494 9.25C7.62494 9.73325 8.01669 10.125 8.49994 10.125C8.98319 10.125 9.37494 9.73325 9.37494 9.25Z" fill="#475161" />
      <path d="M9.37494 4.75C9.37494 4.26675 8.98319 3.875 8.49994 3.875C8.01669 3.875 7.62494 4.26675 7.62494 4.75C7.62494 5.23325 8.01669 5.625 8.49994 5.625C8.98319 5.625 9.37494 5.23325 9.37494 4.75Z" fill="#475161" />
      <path d="M13.6249 9.25C13.6249 8.76675 13.2332 8.375 12.7499 8.375C12.2667 8.375 11.8749 8.76675 11.8749 9.25C11.8749 9.73325 12.2667 10.125 12.7499 10.125C13.2332 10.125 13.6249 9.73325 13.6249 9.25Z" fill="#475161" />
      <path d="M13.6249 4.75C13.6249 4.26675 13.2332 3.875 12.7499 3.875C12.2667 3.875 11.8749 4.26675 11.8749 4.75C11.8749 5.23325 12.2667 5.625 12.7499 5.625C13.2332 5.625 13.6249 5.23325 13.6249 4.75Z" fill="#475161" />
    </svg>
  )
}

export default SvgComponent
